/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Maintenance_Location_Subtitle_GatewaysInputs */



/**
* | output |
* | --- |
* | "Click on the floor to open it" |
*
* @param {Advanced_Maintenance_Location_Subtitle_GatewaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const advanced_maintenance_location_subtitle_gateways = /** @type {((inputs?: Advanced_Maintenance_Location_Subtitle_GatewaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Maintenance_Location_Subtitle_GatewaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Click on the floor to open it")
	return /** @type {LocalizedString} */ ("Cliquer sur le niveau pour y accéder")
});